/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';

import useTranslate from 'hooks/useTranslate';
import SkipPrefillButton from 'features/SkipPrefillButton';
import Link from 'components/Link';
import useWorkflow, { Step } from 'hooks/useWorkflow';
import CancelButton from 'features/CancelButton';
import { useMarkdownMultilineTranslate } from 'hooks/useTranslate/useTranslate';
import SimpleMessagePage from 'components/SimpleMessagePage';

const ErrorView: React.FC = () => {
  const { pathAfter } = useWorkflow();
  const t = useTranslate();
  const tMdMultiline = useMarkdownMultilineTranslate();
  return (
    <SimpleMessagePage
      headerTitle="batchPrescreen.error.title"
      message={tMdMultiline('batchPrescreen.error.message')}
    >
      <SkipPrefillButton
        variant="contained"
        id="continueToApplication"
        component={Link}
        to={pathAfter(Step.BATCH_PRESCREEN_START)}
      >
        {t('batchPrescreen.error.continueButton')}
      </SkipPrefillButton>

      <CancelButton />
    </SimpleMessagePage>
  );
};

export default ErrorView;
